import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import { RouterService } from '@core/services/router.service';
import { StorageService } from '@core/services/storage.service';
import { PAGE_BASE, isProd } from '@core/utils/environment';
import { IS_HETAO_OJ } from '@core/utils/runtime-config';

@Injectable()
export class ZoneService {
  public zone = '';
  // 只有在第一次访问页面时，本地没有zone时才会弹出选择域的弹窗
  // 随后再刷新页面，因为本地已经有zone了，所以不会再弹出选择域的弹窗
  public showSelectZoneModal = false;

  @Inject(forwardRef(() => StorageService))
  public storageService!: StorageService;

  @Inject(forwardRef(() => RouterService))
  public routerService!: RouterService;

  public isCpp() {
    return this.zone === 'cpp';
  }

  public isPython() {
    return this.zone === 'python';
  }

  public getSiteUrl() {
    return IS_HETAO_OJ ? `${PAGE_BASE}/${this.zone}` : PAGE_BASE;
  }

  public getZoneBase() {
    return IS_HETAO_OJ ? `/${this.zone}` : '';
  }

  /**
   * 初始化zone
   */
  public initZone(zone: string) {
    this.zone = zone;
    if (IS_HETAO_OJ) {
      // 只有hetao OJ需要处理域
      // saas OJ不需要处理域
      this.updateZoneIfLocalEmpty(zone);
    }
  }

  /**
   * 更新本地的zone
   */
  public updateZone(zone: string) {
    this.zone = zone;
    this.storageService.setZone(zone);
    this.routerService.updateZone(zone);
  }

  /**
   * 一般情况下用户访问的域和本地域不一致时是不会强制覆盖本地域的
   * 但是特殊情况下是需要强制覆盖本地域的，比如从客户端直接跳转到OJ
   */
  public updateZoneOnly(zone?: string) {
    this.zone = zone || this.zone;
    this.storageService.setZone(this.zone);
  }

  /**
   * 如果本地zone为空，更新本地zone
   */
  public updateZoneIfLocalEmpty(zone: string) {
    const localZone = this.storageService.getZone();
    if (!localZone) {
      this.zone = zone;
      this.showSelectZoneModal = true;
      this.storageService.setZone(zone);
      this.storageService.setZoneGuideNeedShow();
    }
  }

  /**
   * 通过弹窗来选择默认的zone
   * 选择完毕后更新本地zone并且设置zone引导
   */
  public updateZoneFromModal() {
    this.storageService.setZoneGuideNeedShow();
    this.updateZone(this.zone);
  }

  public removeZoneGuide() {
    this.storageService.removeZoneGuide();
  }

  public needShowZoneGuide() {
    return this.storageService.isZoneGuideNeedShow();
  }

  public needShowZoneModal() {
    return this.showSelectZoneModal;
  }
}
